export default "__VITE_ASSET__D24PrOfe__"